import { useNavigate } from 'react-router-dom'
import EntitiesSort from './EntitiesSort'
import { Sort, IssueType } from 'util/constants'
import { Select, SelectTrigger, SelectContent, SelectItem, SelectValue } from 'ui/InputSelect'

interface Props {
    sort: Sort
    searchParams: URLSearchParams
}

const IssuesListSelector = ({ sort, searchParams }: Props) => {
    const navigate = useNavigate()
    const typeFilter = searchParams.get('typeFilter') || 'All'

    const handleSortChange = (newSort: Sort) => {
        const newSearchParams = new URLSearchParams(searchParams)
        navigate(`/issues/${newSort}?${newSearchParams.toString()}`)
    }

    const handleTypeChange = (newType: IssueType) => {
        const newSearchParams = new URLSearchParams(searchParams)
        newSearchParams.set('typeFilter', newType ?? 'Type')
        navigate(`/issues/${sort}?${newSearchParams.toString()}`)
    }

    return (
        <div className="flex gap-1 items-center">
            <EntitiesSort entityType="issue" sort={sort} onSortChange={handleSortChange} />
            <Select value={typeFilter} onValueChange={(value) => handleTypeChange(value as IssueType)}>
                <SelectTrigger className="px-3 py-2">
                    <SelectValue placeholder="Type" />
                </SelectTrigger>
                <SelectContent>
                    {typeFilter && typeFilter !== 'All' ? <SelectItem value="All">Any Type</SelectItem> : 
                      <SelectItem value="All">Type</SelectItem>}
                      <SelectItem value="Person">Person</SelectItem>
                      <SelectItem value="Organization">Organization</SelectItem>
                      <SelectItem value="Territory">Territory</SelectItem>
                      <SelectItem value="Place">Place</SelectItem>
                      <SelectItem value="Incident">Incident</SelectItem>
                      <SelectItem value="CreativeWork">CreativeWork</SelectItem>
                      <SelectItem value="Artifact">Artifact</SelectItem>
                      <SelectItem value="Software">Software</SelectItem>
                      <SelectItem value="Regulation">Regulation</SelectItem>
                      <SelectItem value="Ideology">Ideology</SelectItem>
                      <SelectItem value="Concept">Concept</SelectItem>
                      <SelectItem value="Phenomenon">Phenomenon</SelectItem>
                      <SelectItem value="Species">Species</SelectItem>
                      <SelectItem value="Material">Material</SelectItem>
                      <SelectItem value="Environment">Environment</SelectItem>
                      <SelectItem value="Compound">Influence</SelectItem>
                      <SelectItem value="Other">Other</SelectItem>
                </SelectContent>
            </Select>
        </div>
    )
}

export default IssuesListSelector